/** @format */

import HamburgerIcon from '@/assets/icons/dovevivo_icon_hamburger.svg';
import HamburgerIconLight from '@/assets/icons/dovevivo_icon_hamburger_light.svg';
import { UIRow } from '@/components/ui/Grid/Row';
import { LoginLink } from '@/components/ui/Navbar/index.style';
import { useToggleZendeskWidget } from '@/ducks/general/hooks/useToggleZendeskWidget';
import { TTranslation, useAppTranslation } from '@/i18n/declarations';
import { NAME_PORTAL_CODE } from '@/utils/gatsby/constants';
import { TLocale } from '@/utils/gatsby/types';
import React, { FunctionComponent as FC, memo, useEffect, useMemo, useState } from 'react';
import { StringParam, useQueryParam } from 'use-query-params';
import { TOtherPaths } from '../../../@ducks/general/declarations';
import { ButtonClose, ButtonOpen, Footer, Menu, Outer } from './MobileBar.style';
import { RenderPages } from './RenderPages';
import { RenderPagesExt } from './RenderPagesExt';
import { SwitchLocaleMobile } from './SwitchLocaleMobile';

const Navbar: FC<MobileBarProps> = ({ otherPaths, page, localesDisabled }) => {
  const { t } = useAppTranslation();
  const [showMobileMenu, setShowMobileMenu] = useState<boolean>(false);
  const [portalCode = NAME_PORTAL_CODE] = useQueryParam('portalCode', StringParam);
  const [isExternalPortalCode, setIsExternalPortalCode] = useState(portalCode !== NAME_PORTAL_CODE);

  useEffect(() => {
    setIsExternalPortalCode(portalCode !== NAME_PORTAL_CODE);
  }, [portalCode]);

  const HamburgerSrc = useMemo(() => {
    if (page === 'home' || page === 'listing' || page === 'booking') return HamburgerIconLight;
    return HamburgerIcon;
  }, [page]);

  useToggleZendeskWidget(showMobileMenu, 1475);

  return (
    <>
      <ButtonOpen onClick={() => setShowMobileMenu(true)}>
        <img src={HamburgerSrc} alt="Hamburger menu" />
      </ButtonOpen>
      {showMobileMenu && (
        <Outer>
          <Menu>
            {!isExternalPortalCode && page !== 'booking' ? <RenderPages mobile /> : <RenderPagesExt mobile />}
          </Menu>
          {!isExternalPortalCode && (
            <LoginLink to="/log-in" mobile>
              <span>{t('log-in.sign-in' as TTranslation)}</span>
            </LoginLink>
          )}
          <UIRow>
            <Footer>
              <SwitchLocaleMobile otherPaths={otherPaths} localesDisabled={localesDisabled} />
              <ButtonClose onClick={() => setShowMobileMenu(false)}>{t('close')}</ButtonClose>
            </Footer>
          </UIRow>
        </Outer>
      )}
    </>
  );
};

export const MobileBar = memo(Navbar);

interface MobileBarProps {
  otherPaths: TOtherPaths;
  page: 'page' | 'booking' | 'req-info' | 'listing' | 'room' | 'home' | 'blog';
  localesDisabled?: TLocale[];
}
